// src/components/dashboards/dashboardInk.ts
// ---------------------------------------------------------------------------
// Ink for dashboard surfaces, resolved per variant.
//
// The dashboard components were written for the LIGHT surface and read their
// text colour as:
//
//     theme.custom?.contentText?.primary || theme.palette.text.primary
//
// Both sides of that resolve to deepNavy / blueGray, which is right on the
// pastel dashboard and invisible on the dark one: axis labels, environment
// chips, tab labels and chart titles all vanish. That is the same failure the
// /billing and /superadmin pass fixed (cursor_logs/069), arriving here because
// the dashboard redesign changed the surface under components that were never
// converted.
//
// One hook so a component does not have to know which surface it is on.
// ---------------------------------------------------------------------------

import { useTheme } from "@mui/material";
import { glass } from "../../theme/glassTokens";
import { useIsDashboardSurface } from "./dashboardSurface";

export function useDashboardInk() {
  const theme = useTheme();
  const dark = useIsDashboardSurface();

  return {
    dark,
    primary: dark
      ? glass.textPrimary
      : theme.custom?.contentText?.primary || theme.palette.text.primary,
    secondary: dark
      ? glass.textSecondary
      : theme.custom?.contentText?.secondary || theme.palette.text.secondary,
    /** Panel fill for cards sitting ON the dashboard surface. */
    panel: dark ? glass.panel : undefined,
    panelBorder: dark ? glass.panelBorder : undefined,
    /** Accent that stays visible on either surface. */
    accent: dark ? glass.accent : theme.palette.primary.main,
  };
}
